import { type HTMLAttributes } from "react";
import { Link } from "react-router-dom";
import { cn } from "./utils/cn";

export interface NotesIndexPost {
  number: string;
  slug: string;
  title: string;
  excerpt: string;
  byline: string;
  date: string;
  readingMinutes: number;
}

export interface NotesIndexProps extends HTMLAttributes<HTMLDivElement> {
  posts: NotesIndexPost[];
}

export const NotesIndex = ({ posts, className, ...rest }: NotesIndexProps) => {
  if (posts.length === 0) return <div className={cn("hui-notes-index", className)} {...rest} />;
  const [lead, ...rest_] = posts;
  return (
    <div className={cn("hui-notes-index", className)} {...rest}>
      <Link to={`/notes/${lead.slug}`} className="hui-notes-index__lead">
        <span className="hui-notes-index__num">{lead.number}</span>
        <h2 className="hui-notes-index__title">{lead.title}</h2>
        <p className="hui-notes-index__excerpt">{lead.excerpt}</p>
        <div className="hui-notes-index__meta">
          {lead.byline} · {lead.date} · {lead.readingMinutes} min
        </div>
      </Link>
      <div className="hui-notes-index__grid">
        {rest_.map((p) => (
          <Link key={p.slug} to={`/notes/${p.slug}`} className="hui-notes-index__card">
            <span className="hui-notes-index__num">{p.number}</span>
            <h3 className="hui-notes-index__title hui-notes-index__title--small">{p.title}</h3>
            <p className="hui-notes-index__excerpt">{p.excerpt}</p>
            <div className="hui-notes-index__meta">
              {p.byline} · {p.date} · {p.readingMinutes} min
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
